<template>
  <v-app class="bgImage">
    <v-app-bar app color="primary">
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">Forgot </span>
        <span class="font-weight-medium">Password</span>
      </v-toolbar-title>
    </v-app-bar>

    <v-content class="secondary--text text--darken-2">
      <v-container fill-height>
        <v-row class="fill-height">
          <v-col cols="12">
            <v-row fill-height justify="center">
              <v-col xs="12" sm="8" md="6" lg="4">
                <v-card v-if="requestSent" class="mt-10">
                  <v-card-title
                    class="primary text-center pa-4 secondary--text text--darken-3"
                  >
                    <v-row justify="center">
                      <span
                        class="text-uppercase text-center font-weight-light"
                      >
                        <span class="font-weight-medium">
                          Request Sent
                        </span>
                      </span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mb-2 mt-4 text-center">
                    <h3>
                      An email has been sent to your registered email address.
                      Please check your email and click the provided link.
                    </h3>
                  </v-card-text>
                  <v-card-actions>
                    <v-row align="center" justify="center">
                      <v-btn
                        text
                        color="primary"
                        class="mb-3"
                        @click="$router.push('/')"
                      >
                        Go to Login Page
                      </v-btn>
                    </v-row>
                  </v-card-actions>
                </v-card>
                <v-card v-else class="mt-10">
                  <v-card-title
                    class="primary text-center pa-4 secondary--text text--darken-3"
                  >
                    <v-row justify="center">
                      <span
                        class="text-uppercase text-center font-weight-light"
                      >
                        <span class="font-weight-medium">
                          Forgot Password
                        </span>
                      </span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mb-2 mt-4 text-center">
                    <p>
                      Forgot your password? Don't worry
                      {{ capitaliseFirstLetter(appNameFirst) }}.{{
                        capitaliseFirstLetter(appNameSecond)
                      }}
                      has your back! Just enter your regisetered email address
                      and we will send you a link allowing you to create a new
                      password.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-row align="center" justify="center">
                      <m-form
                        v-slot="{ model }"
                        :query="apiEndpoints.emailPassword"
                        :rules="validationRules"
                        :modelSrc="registrationData"
                        @success="onSuccess"
                        lazy-validation
                      >
                        <v-row align="center" justify="center">
                          <m-textinput
                            :model="model"
                            name="email"
                            label="Registered Email Address"
                            required
                          ></m-textinput>
                        </v-row>
                        <v-row>
                          <m-submit label="Send Link" :model="model">
                          </m-submit>
                          <v-btn
                            text
                            color="primary"
                            class="mb-3"
                            @click="$router.push('/')"
                          >
                            Back to Login Page
                          </v-btn>
                        </v-row>
                      </m-form>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiQueries from "../mixins/api-endpoints";

export default {
  mixins: [apiQueries],
  data() {
    return {
      appNameFirst: process.env.MIX_APPNAME_FIRST,
      appNameSecond: process.env.MIX_APPNAME_SECOND,
      requestSent: false,
      registrationData: {
        email: ""
      },
      passwordConfirm: "",
      validationRules: {
        email: model => [
          v => !!v || "E-mail is required",
          v => /.+@.+\..+/.test(v) || "E-mail must be valid"
        ]
      }
    };
  },
  methods: {
    onSuccess: function(body) {
      this.requestSent = true;
      //this.$router.push("/");
    },
    capitaliseFirstLetter: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
  },
  mounted() {}
};
</script>
